// @flow
/** @jsx jsx */

import * as React from 'react';
import { jsx, css } from '@emotion/core';

import type { ActionStatus } from '../types';
import colors from '../config/colors';

type Props = {
  status: ?ActionStatus,
  children: any,
  delaySuccess?: number,
  delayError?: number,
  autoHide?: boolean,
};

type State = {
  status: ActionStatus,
};

const base = css`
  padding: 5px 10px;
  border-radius: 3px;
  max-width: 450px;
  text-align: center;
`;

const getStyles = (status: ?ActionStatus): any => {
  switch (status) {
    case 'completed':
      return css`
        background-color: ${colors.lime};
        color: ${colors.white};
      `;
    case 'error':
      return css`
        background-color: ${colors.red};
        color: ${colors.white};
      `;
    default:
      return false;
  }
};

class StatusMessage extends React.Component<Props, State> {
  timer: TimeoutID;

  static defaultProps = {
    delaySuccess: 5000,
    delayError: 10000,
    autoHide: true,
  };

  state = {
    status: '',
  };

  oldDerivedStateFromProps(nextProps: Props, prevState: State) {
    const { status } = nextProps;

    if (status !== '' && prevState.status === '') {
      return this.setState({
        status,
      });
    }

    return null;
  }

  componentDidMount() {
    this.oldDerivedStateFromProps(this.props, this.state);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.oldDerivedStateFromProps(this.props, this.state);
    }
    
    if (this.state.status !== 'completed' && this.state.status !== 'error') {
      return;
    }

    if (this.timer) {
      clearTimeout(this.timer);
    }

    if (!this.props.autoHide) {
      return;
    }

    this.timer = setTimeout(
      () => {
        this.setState({
          status: '',
        });
      },
      this.state.status === 'error'
        ? this.props.delayError
        : this.props.delaySuccess,
    );
  }

  render() {
    return (
      this.state.status !== '' && (
        <div css={[base, getStyles(this.state.status)]}>
          {this.props.children}
        </div>
      )
    );
  }
}

export default StatusMessage;
